import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-graphic-data',
  templateUrl: './no-graphic-data.component.html',
  styleUrls: ['./no-graphic-data.component.scss']
})
export class NoGraphicDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
